export default String.raw`
{% assign name = include -%}
{% assign banner = config.Banners[name] -%}

{% comment -%}<!-- Category Banner -->{% endcomment -%}
{% assign isCategoryBanner = false -%}
{% assign shouldRenderBanner = true -%}

{% if page.PageId == config.DefinedPages.ProductList.Id and config.CategoriesBanners[name] -%}
    {% assign banner = config.CategoriesBanners[name] -%}
    {% assign isCategoryBanner = true -%}
    {% assign shouldRenderBanner = false -%}

    {% comment -%}<!-- Check if any image matches current category -->{% endcomment -%}
    {% for image in banner.Images -%}
        {% assign categoryIds = image.Categories | Map: 'CategoryId' -%}
        {% for categoryId in categoryIds -%}
            {% if categoryId == products.HeaderData.Id -%}
                {% assign shouldRenderBanner = true -%}
                {% break -%}
            {% endif -%}
        {% endfor -%}
    {% endfor -%}

    {% comment -%}<!-- Show placeholder if CategoriesBanners exists but Images array is empty -->{% endcomment -%}
    {% if banner.Images.size == 0 -%}
        {% assign shouldRenderBanner = true -%}
    {% endif -%}
{% endif -%}

{% if banner and shouldRenderBanner -%}
    <section class="mainBanner" data-name="{{ name }}" data-timer="{% if settings.mainBannerSlideAutoplayToggle == 'yes' -%}{{settings.mainBannerSliderAutoplaySpeed}}{% endif -%}">
        <div tabindex="0" role="button" aria-label="{{translations.PrevSlide}}" class="mainBanner__prev arrow shadowed {{ name }}__prev">
            <svg class="arrow__icon">
                <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
            </svg>
        </div>
        <div tabindex="0" role="button" aria-label="{{translations.NextSlide}}" class="mainBanner__next arrow shadowed {{ name }}__next">
            <svg class="arrow__icon">
                <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
            </svg>
        </div>
        <div class="swiper mainBanner__swiper {{ name }}">
            <div class="swiper-wrapper mainBanner__wrapper" data-len="{{ banner.Images.size }}">
                {% if banner.Images.size > 0 -%}
                    {% for slide in banner.Images -%}
                        {% comment -%}<!-- For category banners, check if slide matches current category -->{% endcomment -%}
                        {% assign shouldRenderSlide = true -%}
                        {% if isCategoryBanner == true -%}
                            {% assign categoryIds = slide.Categories | Map: 'CategoryId' -%}
                            {% assign shouldRenderSlide = false -%}
                            {% for categoryId in categoryIds -%}
                                {% if categoryId == products.HeaderData.Id -%}
                                    {% assign shouldRenderSlide = true -%}
                                    {% break -%}
                                {% endif -%}
                            {% endfor -%}
                        {% endif -%}

                        {% if shouldRenderSlide -%}
                            <div class="swiper-slide mainBanner__slide">
                                {% if slide.Link != '' and (slide.Text == '' or slide.Heading == '') -%}
                                    {% capture slideHref -%}{% include 'partials/common/user-link.html', userLink: slide.Link -%}{% endcapture -%}
                                    <a href="{{ slideHref }}" {% if slide.TargetBlank == true %} target="_blank" {% endif %} rel="noopener noreferrer">
                                {% endif -%}
                                    <picture>
                                        <source media="(max-width: 767px)" srcset="{{ slide.UrlSmall }}" type="image/webp">
                                        <source media="(max-width: 767px)" srcset="{{ slide.UrlSmall }}">
                                        <source media="(max-width: 1439px)" srcset="{{ slide.UrlMedium }}" type="image/webp">
                                        <source media="(max-width: 1439px)" srcset="{{ slide.UrlMedium }}">
                                        <source srcset="{{ slide.Url }}" type="image/webp">

                                        <img src="{{ slide.Url }}" 
                                            alt="{{ slide.Alt }}"
                                            width="1574" 
                                            height="425"
                                            decoding="{% if forloop.index0 == 0 -%}sync{% else -%}async{% endif -%}"
                                            {% unless settings.bodyMainBannerNo_1 == 1 -%}loading="{% if forloop.index0 == 0 -%}eager{% else -%}lazy{% endif -%}"{% else -%}fetchpriority="high"{% endunless -%}
                                        >
                                    </picture>
                                {% if slide.Link != '' and (slide.Text == '' or slide.Heading == '') -%}
                                    </a>
                                {% endif -%}
                                {% if slide.Heading != '' or slide.Text != '' -%}
                                    <div class="mainBanner__slide-container">
                                        <div class="mainBanner__slide-container-box">
                                            {% if slide.Heading != '' -%}
                                                <h1 {% if slide.Text == '' and slide.Link == '' -%}style="margin-bottom: 0;"{% endif -%}>{{ slide.Heading }}</h1>
                                            {% endif -%}
                                            {% if slide.Text != '' -%}
                                                <h3 {% if slide.Link == '' -%}style="margin-bottom: 0;"{% endif -%}>{{ slide.Text }}</h3>
                                            {% endif -%}
                                            {% if slide.Link != '' -%}
                                                {% capture slideHref -%}{% include 'partials/common/user-link.html', userLink: slide.Link -%}{% endcapture -%}
                                                <a class="primary-action-button" href="{{ slideHref }}" {% if slide.TargetBlank == true %} target="_blank" {% endif %} rel="noopener noreferrer">
                                                    {{ translations.Look }}
                                                </a>
                                            {% endif -%}
                                        </div>
                                    </div>
                                {% endif -%}
                            </div>
                        {% endif -%}
                    {% endfor -%}
                {% else -%}
                    {% for slide in (1..3) -%}
                        <div class="swiper-slide mainBanner__slide">
                            <div class="placeholder">
                                <img class="placeholder__image"
                                    src="css/img/img-placeholder.jpg" 
                                    width="1574" 
                                    height="425"
                                    decoding="{% if forloop.index0 == 0 -%}sync{% else -%}async{% endif -%}"
                                    {% unless settings.bodyMainBannerNo_1 == 1 -%}loading="{% if forloop.index0 == 0 -%}eager{% else -%}lazy{% endif -%}"{% else -%}fetchpriority="high"{% endunless -%}
                                    alt="Placeholder">
                                <h1 class="mainBanner__slide-placeholder">{{ name }}<br>1574x425<br></h1>
                            </div>
                        </div>
                    {% endfor -%}
                {% endif -%}
            </div>
            <div class="swiper-pagination"></div>
            <div aria-label="{{translations.PauseSlide}}" role="button" tabindex="0" class="mainBanner-pause-button swiper-button-pause">
                <svg class="pause-icon">
                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#pause-circle-{{ settings.iconStyle }}'></use>
                </svg>
            </div>
        </div>
    </section>
{% endif -%}
`